import React from 'react';
import DashboardAdvertiseCard from '../DashboardAdvertiseCard';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIEText from '@src/shared/components/PIEText';
import TagNew from '../DashboardCustomTag/components/TagNew';
import { useTranslation } from 'react-i18next';
import style from './DashboardStatisticsBannerMobile.module.scss';
import { IconChartIncrease } from '@justeattakeaway/pie-icons-react';
interface componentProps {
  onClick?: () => void;
}
const DashboardStatisticsBannerMobile = ({ onClick }: componentProps) => {
  const { t } = useTranslation();
  return (
    <PIEComponentUtil marginTop="var(--xds-spacing-e)">
      <DashboardAdvertiseCard
        className="dashboard-statistics-button"
        onClick={onClick}
        insertLeft={
          <PIEComponentUtil marginRight="var(--xds-spacing-d)">
            <IconChartIncrease size="l" />
          </PIEComponentUtil>
        }
        title={
          <PIEText
            text={
              <>
                {t('deliverydata.MENU_TITLE')}{' '}
                <TagNew className={style.newBadge}>
                  <PIEText
                    text={t('deliverydata.MENU_TITLE_TAG')}
                    color="var(--xds-color-content-light)"
                    size="var(--xds-font-size-12)"
                    fontWeight="var(--xds-font-weight-regular)"
                  />
                </TagNew>
              </>
            }
            color="var(--xds-color-content-default)"
            size="var(--xds-font-size-16)"
            fontWeight="var(--xds-font-weight-bold)"
          />
        }
        description={
          <PIEText
            text={t('deliverydata.MENU_SUB_TITLE')}
            color="var(--xds-color-content-default)"
            size="var(--xds-font-size-14)"
            fontWeight="var(--xds-font-weight-regular)"
          />
        }
      />
    </PIEComponentUtil>
  );
};

export default DashboardStatisticsBannerMobile;
